export default "__VITE_ASSET__1d780700__"